import React, { useState } from 'react';
import { OrganicBlob, OrganicBlob2 } from "../../../shared/decorations/OrganicBlob";
import AuthModal from '../../../shared/auth/AuthModal';
import { useAuth } from '../../../core/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export function FooterCTA() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleCTA = () => {
    if (currentUser && currentUser.emailVerified) {
      // User is authenticated and verified, go to game
      navigate('/game');
    } else {
      // Show auth modal
      setShowAuthModal(true);
    }
  };

  return (
    <>
      <section className="px-6 text-center relative overflow-hidden" style={{ paddingTop: '120px', paddingBottom: '120px' }}>
        {/* Background decorations */}
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <OrganicBlob className="absolute w-72 h-72 -left-16 top-0 animate-pulse" style={{ animationDelay: '0.7s' }} />
          <OrganicBlob2 className="absolute w-64 h-64 -right-12 bottom-0 animate-pulse" style={{ animationDelay: '1.3s' }} />
        </div>

        <div className="max-w-[600px] mx-auto relative z-10">
          <h2
            className="mb-8"
            style={{
              color: '#FAFAF8',
              fontSize: '40px',
              fontWeight: '600'
            }}
          >
            Ready for your daily escape?
          </h2>

          <button
            onClick={handleCTA}
            className="px-12 py-5 transition-all duration-300 hover:shadow-[0_0_25px_rgba(139,157,131,0.5)] hover:scale-105 mb-6"
            style={{
              backgroundColor: '#8B9D83',
              color: '#FAFAF8',
              borderRadius: '28px',
              fontSize: '18px',
              fontWeight: '500',
            }}
          >
            {currentUser && currentUser.emailVerified
              ? 'Play Now'
              : 'Join HU Games'}
          </button>

          {/* Optional subtext */}
          <p style={{ color: '#E8DCC4', fontSize: '14px' }}>
            @bison.howard.edu emails only
          </p>
        </div>
      </section>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        initialMode="signup"
      />
    </>
  );
}
